import React from 'react';
import AuthToolbar from '../Layout/AuthToolbar'

const GroupContent = () => {
    const breadcumb = [
		{
			item: 'Home',
			path: '/'
		},
		{
			item: 'Settings',
			path: ''
		},
        {
			item: 'Groups',
			path: ''
		}
    ]
    return (
        <React.Fragment>
            <AuthToolbar 
                title='Groups'
                breadcumb = {breadcumb}
            />
        </React.Fragment>
    );
}

export default GroupContent;